import { __decorate } from "tslib";
import { computed } from 'mobx';
import { columnWidth } from './Column';
import ColumnGroups from './ColumnGroups';
import { getColumnKey } from './utils';
export default class ColumnGroup {
    constructor(column, parent) {
        this.column = column;
        this.parent = parent;
        const { children } = column;
        if (children && children.length > 0) {
            this.children = new ColumnGroups(children, this);
        }
    }
    get key() {
        return getColumnKey(this.column);
    }
    get rowSpan() {
        return this.parent.deep - this.deep + 1;
    }
    get colSpan() {
        return this.children ? this.children.wide : 1;
    }
    get deep() {
        return this.children ? this.children.deep + 1 : this.hidden ? 0 : 1;
    }
    get hidden() {
        return this.children ? this.children.hidden : !!this.column.hidden;
    }
    get lastLeaf() {
        return this.children ? this.children.lastLeaf : this.column;
    }
    get width() {
        return this.children ? this.children.width : columnWidth(this.column);
    }
    get left() {
        const { prev, parent } = this;
        if (prev) {
            return prev.left + prev.width;
        }
        if (parent) {
            return parent.left;
        }
        return 0;
    }
    get right() {
        const { next, parent } = this;
        if (next) {
            return next.right + next.width;
        }
        if (parent) {
            return parent.right;
        }
        return 0;
    }
}
__decorate([
    computed
], ColumnGroup.prototype, "key", null);
__decorate([
    computed
], ColumnGroup.prototype, "rowSpan", null);
__decorate([
    computed
], ColumnGroup.prototype, "colSpan", null);
__decorate([
    computed
], ColumnGroup.prototype, "deep", null);
__decorate([
    computed
], ColumnGroup.prototype, "hidden", null);
__decorate([
    computed
], ColumnGroup.prototype, "lastLeaf", null);
__decorate([
    computed
], ColumnGroup.prototype, "width", null);
__decorate([
    computed
], ColumnGroup.prototype, "left", null);
__decorate([
    computed
], ColumnGroup.prototype, "right", null);
